import { useSignups } from "Signups/state";

import { useNewSignupCreationFlow } from "../NewSignup";
import FundIt from "../SignupSheet/Screens/FundIt";
import Options from "../SignupSheet/Screens/Options";
import RespondentsData from "../SignupSheet/Screens/RespondentsData";
import SignupItems from "../SignupSheet/Screens/SignupItems";

import { useIsSignupEligibleForFundIt } from "./stateHooks";

const useTabsConfig = () => {
  const [
    {
      currentSignupList: { ID },
      user: { isAdminOfAnyGroup },
    },
  ] = useSignups();
  const { forceToAddItem } = useNewSignupCreationFlow();
  const isSignupEligibleForFundIt = useIsSignupEligibleForFundIt();
  const baseUrl = `/signups/${ID}/`;

  const tabsConfig = [
    {
      key: "items",
      content: SignupItems,
      label: "Items",
      icon: "list-alt far",
      url: `${baseUrl}items`,
    },
  ];

  if (isAdminOfAnyGroup)
    tabsConfig.push({
      key: "respondents",
      content: RespondentsData,
      label: "Respondent Data",
      icon: "table far",
      url: `${baseUrl}respondents`,
      disabled: forceToAddItem,
    });

  if (isSignupEligibleForFundIt && isAdminOfAnyGroup)
    tabsConfig.push({
      key: "fund-it",
      content: FundIt,
      label: "Take Payments",
      icon: "money-bill far",
      url: `${baseUrl}fund-it`,
      disabled: forceToAddItem,
    });

  tabsConfig.push({
    key: "options",
    content: Options,
    label: "Signup Options",
    icon: "sliders-h far",
    url: `${baseUrl}options`,
    disabled: forceToAddItem,
  });

  return tabsConfig;
};

export default useTabsConfig;
